import {
  Archive as ArchiveXIcon,
  CheckIcon,
  CopyIcon,
  TrashIcon,
} from "lucide-react";
import { BaseGeneralFormSchema } from "@/lib/schemas/generalContract";
import { InputRequiredStatus, InputFormType, InputType } from "@/lib/form";
import moment from "moment-timezone";
import { CommonDestinationTimezone } from "@/lib/utils";

export const BaseFormSchema = {
  duplicate_contract_button: {
    label: "",
    action_reference_id: "onDuplicate",
    action: "button",
    derived: true,
    skipForm: true,
    apiDisplayFormat: ({ original }: any) => {
      return <CopyIcon className="h-4 w-4" />;
    },
  },
  archive_contract_button: {
    label: "Archive",
    action_reference_id: "onArchive",
    action: "button",
    derived: true,
    skipForm: true,
    apiDisplayFormat: ({ original }: any) => {
      return <ArchiveXIcon className="h-4 w-4" />;
    },
  },
  created_at: {
    label: "Created At",
    input_type: InputType.Date,
    input_type_validation: InputFormType.Date,
    required_status: InputRequiredStatus.Optional,
    apiDisplayFormat: ({ original }: any) => {
      if (!original.created_at) return "";
      return moment
        .tz(original.created_at, CommonDestinationTimezone)
        .format("hh:mm A MM/DD/YYYY");
    },
  },
  ...BaseGeneralFormSchema,
};

export const StagedFormSchema = {
  duplicate_contract_button: {
    label: "",
    action_reference_id: "onDuplicate",
    action: "button",
    derived: true,
    skipForm: true,
    apiDisplayFormat: ({ original }: any) => {
      return <CopyIcon className="h-4 w-4" />;
    },
  },
  archive_contract_button: {
    label: "Reviewed",
    action_reference_id: "onReview",
    action: "button",
    derived: true,
    skipForm: true,
    apiDisplayFormat: ({ original }: any) => {
      return <CheckIcon className="h-4 w-4" />;
    },
  },
  delete_contract_button: {
    label: "Delete",
    action_reference_id: "onDelete",
    action: "button",
    derived: true,
    skipForm: true,
    apiDisplayFormat: ({ original }: any) => {
      return <TrashIcon className="h-4 w-4" />;
    },
  },
  created_at: {
    label: "Created At",
    input_type: InputType.Date,
    input_type_validation: InputFormType.Date,
    required_status: InputRequiredStatus.Optional,
    apiDisplayFormat: ({ original }: any) => {
      if (!original.created_at) return "";
      return moment
        .tz(original.created_at, CommonDestinationTimezone)
        .format("hh:mm A MM/DD/YYYY");
    },
  },
  ...BaseGeneralFormSchema,
};

export const DownloadRecentFormSchema = {
  created_date: {
    label: "Created Date",
    input_type: InputType.Date,
    input_type_validation: InputFormType.Date,
    required_status: InputRequiredStatus.Required,
  },
};

